import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { usePrefs, useLabels } from 'ws-scripts/modules/common';
import React from 'react';
import { ErrorBoundary } from 'wsm-error-boundary';
import Ratings from '../components/Ratings';
import Reviews from '../components/Reviews';
import Footer from '../components/Footer';

const WidgetContainer = (props) => {
	const {
		ratings,
		ratingScale,
		numberOfReviews,
		generationStartYear,
		generationEndYear
	} = props.kbbCustomerRatings;

	const { items } = props.kbbCustomerReviews;
	const { windowId, widgetName } = props.kbbWidgetInfo;
	const prefs = usePrefs();
	const labels = useLabels();
	const logoColor = prefs.KBBLogoColor === 'light' ? 'light' : 'dark';

	return (
		<ErrorBoundary newRelicPageAction="WS DETAILED KBB REVIEWS ERROR BOUNDARY">
			<div>
				<div className="kbb-header d-flex align-items-center">
					<div className="kbb-logo-container">
						<img
							src={`https://static.dealer.com/global/media/logos/kbb/horizontal/${logoColor}/180x102.png`}
							alt="Kelley Blue Book - KBB.com"
							width={180}
							height={102}
						/>
					</div>
					<Ratings
						ratings={ratings}
						ratingScale={ratingScale}
						prefs={prefs}
					/>
				</div>
				<Reviews
					reviews={items}
					windowId={windowId}
					widgetName={widgetName}
					labels={labels}
					prefs={prefs}
				/>
				<Footer
					totalReviews={numberOfReviews}
					startYear={generationStartYear}
					endYear={generationEndYear}
				/>
			</div>
		</ErrorBoundary>
	);
};

WidgetContainer.propTypes = {
	kbbCustomerRatings: PropTypes.shape({
		ratings: PropTypes.arrayOf(
			PropTypes.shape({
				name: PropTypes.string.isRequired,
				value: PropTypes.string.isRequired
			})
		).isRequired,
		ratingScale: PropTypes.number.isRequired,
		numberOfReviews: PropTypes.number.isRequired,
		generationStartYear: PropTypes.string.isRequired,
		generationEndYear: PropTypes.string.isRequired
	}).isRequired,
	kbbCustomerReviews: PropTypes.shape({
		items: PropTypes.arrayOf(
			PropTypes.shape({
				reviewId: PropTypes.number.isRequired,
				nickName: PropTypes.string.isRequired,
				submissionDate: PropTypes.string.isRequired,
				overallRating: PropTypes.number.isRequired,
				text: PropTypes.string.isRequired
			})
		).isRequired
	}).isRequired,
	kbbWidgetInfo: PropTypes.shape({
		windowId: PropTypes.string.isRequired,
		widgetName: PropTypes.string.isRequired,
		locale: PropTypes.string.isRequired
	}).isRequired
};

const mapStateToProps = (state) => ({
	kbbCustomerRatings: state.ratings,
	kbbCustomerReviews: state.reviews,
	kbbWidgetInfo: state.widgetInfo
});

const mapDispatchToProps = (_dispatch) => ({});

const Widget = connect(mapStateToProps, mapDispatchToProps)(WidgetContainer);

export default Widget;
